var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProjects(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 16,
    fill: "#F39C12",
    fillOpacity: 0.08
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.0953 30.0485V43.4538C50.0953 45.665 48.2957 47.4645 46.0845 47.4645H17.9155C15.7044 47.4645 13.9048 45.665 13.9048 43.4538V20.5497C13.9048 18.3386 15.7044 16.5391 17.9155 16.5391H24.876C26.1798 16.5391 27.3994 17.1686 28.1579 18.2395C29.2287 19.9647 31.3059 23.3508 32.4016 25.1008C32.8081 25.6759 33.522 26.0427 34.2706 26.0427H46.0845C48.2957 26.0427 50.0953 27.8374 50.0953 30.0485Z",
    fill: "#F39C12"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.881 23.7592C33.9781 23.8651 34.1636 23.9799 34.3843 23.9799H46.7878C47.1587 23.9799 47.5296 24.0153 47.8828 24.0859V22.9291C47.8828 20.6066 46.0019 18.7168 43.6794 18.7168H30.7637C31.4404 19.8029 33.1864 22.6342 33.881 23.7592Z",
    fill: "#F39C12"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjects);
export default __webpack_public_path__ + "static/media/projects.4bc472c29deef3d92f5f183dba9fac0c.svg";
export { ForwardRef as ReactComponent };